(ns app.front.view.wizard.party-selector
  (:require [app.domain.party-role.model :as role-model]
            [app.domain.party.model :as party-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.process :as process]
            [app.front.ui.section :as section]
            [app.front.ui.select-card :as select-card]
            [app.front.util :refer [for-frag]]
            [app.front.view.party :as party-view]
            [app.front.view.wizard.buttons :as wizard-buttons]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::deselected-parties
  :-> ::deselected-parties)


(rf/reg-sub ::parties
  :<- [::ws-subs/workspace]
  (fn [workspace]
    (->> (workspace-model/phase-entities workspace)
         (mapcat party-model/phase-parties)
         ;; get the newest party in a chain
         (map party-model/latest-party-copy)
         ;; deduplicate at least mostly identical parties
         (group-by #(select-keys % [:user/first-name
                                    :user/last-name
                                    :user/corporation-or-partnership
                                    :party/email
                                    :party/user
                                    :party/business]))
         (map (comp first last)))))


(rf/reg-sub ::sorted-parties
  :<- [::parties]
  (fn [parties]
    (sort-by :entity/created parties)))


(rf/reg-sub ::selected-parties
  :<- [::parties]
  :<- [::deselected-parties]
  (fn [[parties deselected-parties]]
    (let [deselected-set (set deselected-parties)]
      (into #{}
            (comp
              (map :db/id)
              (remove deselected-set))
            parties))))


(rf/reg-sub ::selected-sorted-parties
  :<- [::sorted-parties]
  :<- [::selected-parties]
  (fn [[sorted-parties selected-parties]]
    (->> sorted-parties
         (filter #(->> % :db/id (contains? selected-parties))))))


(rf/reg-sub ::party-selected?
  :<- [::deselected-parties]
  (fn [deselected-parties [_ party-id]]
    (not-any? #(= % party-id) deselected-parties)))


(rf/reg-event-db ::set-selected-party
  (fn [db [_ party-id selected?]]
    (-> db
        (update ::deselected-parties
                (comp set (if selected? disj conj))
                party-id))))


(defn- party-card [party tr]
  (let [lang                (<sub [:language])
        ctx                 (util/mmap lang tr)
        invite              (-> party :invite/_party first)
        party-id            (:db/id party)
        application         (<sub [::ws-subs/application])
        can-integrate?      (<sub [::process/signal-permitted?
                                   (:db/id application)
                                   [:process.signal/view-integration-contacts]])
        customer-id         (-> application :entity/parent :domain/authority-group :group/id)
        current-int-id      (party-model/integration-id party customer-id)
        backend-system-name (<sub [::ws-subs/backend-system-name])]
    [:div
     [:strong
      (party-model/corporation-and-full-name-or-full-name party lang)]
     [:div.flex.flex-col.md:flex-row
      [:div.flex-1
       [party-view/party-status tr party invite]

       [:div.mt-3 {:key (str party-id "-roles")}
        (for-frag [role (:party/party-roles party)]
          [:div {:key (str party-id role)} (role-model/party-role-name role lang)])]]

      [:div.flex.flex-col.items-end
       [party-view/party-email ctx party invite]
       (when (and can-integrate? current-int-id)
         [:div.party-integration-pill.party-elem__integration-id
          (str backend-system-name " " current-int-id)])]]]))


(defn parties [{:keys [tr next-page back cancel-link]}]
  (if (<sub [::ws-subs/loading-config?])
    [section/section-skeleton]
    (let [parties (<sub [::sorted-parties])]
      [:section
       [:div.bx--row>h2.bx--col-xs-12
        (tr [:wizard/party-heading])]
       [:div.bx--row>p.bx--col-xs-12
        (tr [:wizard/party-description])]
       (when (seq parties)
         (into
           [:div.bx--row.mt-4 {:key :parties-container}]
           (for [party parties]
             [:div.bx--col-xs-12.bx--col-xl-6
              {:key (str (:db/id party) "-party")}
              [select-card/card {:on-select #(>evt [::set-selected-party (:db/id party) %])
                                 :selected? (<sub [::party-selected? (:db/id party)])
                                 :id        (:db/id party)}
               [party-card party tr]]])))
       [wizard-buttons/buttons tr {:next        {:on-click next-page
                                                 :text     (tr [:next])}
                                   :back        {:on-click back}
                                   :cancel-link cancel-link}]])))


(defn selected-parties-summary [tr]
  (let [parties (<sub [::selected-sorted-parties])]
    [:<>
     [:div.bx--row>h3.bx--col-xs-12.mb-0.mt-8
      (tr [:wizard/party-heading])]
     (when (seq parties)
       (into
         [:div.bx--row.mt-4 {:key :parties-container}]
         (for [party parties]
           [:div.bx--col-xs-12.bx--col-lg-6.bx--col-xl-4
            {:key (str (:db/id party) "-party")}
            [:div.p-4.border.border-solid.border-gray-300.rounded-lg
             [party-card party tr]]])))]))
